import { Alert, Box, Typography } from '@mui/material';
import * as React from 'react';
import { QuestionnaireViewerProps } from '../types/viewer.types';
import { QuestionViewer } from './QuestionViewer';
import { ViewerHeader } from './ViewerHeader';

export const QuestionnaireViewer: React.FC<QuestionnaireViewerProps> = ({
  questions,
  responses,
  // dadosServidor,
  title,
}) => {
  // const answeredQuestions = responses.filter((r) => r).length;

  // DEBUG
  // console.log(
  //   'Questions:',
  //   questions.map((q) => q.id)
  // );
  // console.log(
  //   'Responses:',
  //   responses.map((r) => r?.questionId)
  // );

  return (
    <Box sx={{ mt: 12 }}>
      <ViewerHeader
        // dadosServidor={dadosServidor}
        title={title}
        // totalQuestions={questions.length}
        // answeredQuestions={answeredQuestions}
      />
      <Alert
        severity="info"
        sx={{
          ml: 2,
          mr: 2,
          mt: 4,
          mb: 3,
          borderRadius: 2,
          fontSize: 15,
          '& .MuiAlert-message': { lineHeight: 1.6 },
        }}
      >
        <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.25 }}>
          APENAS CONFERÊNCIA DE ENVIO
        </Typography>
        As informações exibidas nesta tela confirmam que as respostas foram
        recebidas pelo sistema.{' '}
        <b style={{ color: '#0864ee' }}>
          Não indicam acerto ou erro nas questões
        </b>{' '}
        e não correspondem à correção da prova.
      </Alert>
      <Box
        sx={{
          maxWidth: 1400,
          mx: 'auto',
          p: 2,
          mt: 3,
        }}
      >
        {questions.map((question, index) => {
          const response = responses.find((r) => r?.questionId === question.id);

          // DEBUG
          // console.log(
          //   `Question ${question.id} - Response found:`,
          //   !!response,
          //   response
          // );

          return (
            <QuestionViewer
              key={question.id}
              question={question}
              questionNumber={index + 1}
              response={response}
            />
          );
        })}
      </Box>
    </Box>
  );
};
